module.exports = __webpack_public_path__ + "img/breakfast.9a3862af.svg";